import {useState} from 'react'
import Password from '../../../../../Common/Password'
import {withStyles} from '@material-ui/core'
import {ClassNameMap} from '@material-ui/core/styles/withStyles'

type PasswordInputProps = {
  classes?: Partial<ClassNameMap<keyof ReturnType<typeof styles>>>;
  disabled?: boolean;
  error: string;
  onChange: (newValue: string) => void;
  value: string;
}

const styles = theme => ({
  formControl:{
    display: 'block',
    margin: '20px 0px'
  },
  error:{
    color: theme.palette.error.main,
  },
  errorMessage:{
    color: theme.palette.error.main,
    display: 'inline-block',
    verticalAlign: 'bottom',
    margin: '13px 13px 13px 0'
  },
})

export const _PasswordInput = ({classes, disabled, error, onChange, value}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <Password
      classes={classes ?? {}}
      disabled={disabled}
      error={error.length > 0}
      errorText={error}
      fullWidth
      onChange={e => onChange(e.target.value)}
      onClickShow={() => setShowPassword(!showPassword)}
      showPassword={showPassword}
      value={value}
    />
  )
}

export const PasswordInput = withStyles(styles)(_PasswordInput)
